import { Component, Input, OnChanges } from '@angular/core';

import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { WEIGHT_UNIT_KG } from '@constants/constants';

@Component({
  selector: 'es-invoice-summary-details-total',
  templateUrl: './es-invoice-summary-details-total.component.html',
  styleUrls: ['./es-invoice-summary-details-total.component.scss'],
})
export class EsInvoiceSummaryDetailsTotalComponent implements OnChanges {
  @Input() public items: any[] = [];
  @Input() public currencyRate = 1;
  @Input() public currency = DEFAULT_CURRENCY_CODE;
  @Input() public title: string;
  @Input() public hideBorderBottom = false;
  @Input() public enteredValueTitle = 'FORM_LABEL.INVOICE_ENTERED_VALUE';
  public commonGrossWeight: number = 0;
  public commonValues: number = 0;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
  public WEIGHT_UNIT_KG: string = WEIGHT_UNIT_KG;

  public ngOnChanges() {
    this.calculateCommonValues();
  }

  private calculateCommonValues() {
    this.commonGrossWeight = 0;
    this.commonValues = 0;
    if (this.items.length) {
      this.items.forEach((item) => {
        this.commonGrossWeight += item.grossWeight;
        this.commonValues += item.value;
      });
    }
  }
}
